module.exports = __webpack_public_path__ + "img/25m.b0b0bade.png";